<template>
  <div>
    <el-dialog v-if="state.product?.id" v-model="state.visible" title="規格選項" :width="isMobile ? '100vw' : '767px'"
      :top="'0px'" modal-class="lite-product-choose-assort-dialog" :before-close="handleClickClose" destroy-on-close
      append-to-body>
      <template #footer>
        <div v-if="!hiddenCart" class="dialog-footer">
          <el-button
            v-if="selectedAssort.id && (selectedAssort.unlimited_inventory === true || selectedAssort.inventory > 0)"
            type="primary" size="large" class="w-full large-button" @click="chooseAssortSubmit">
            <i class="fa fa-shopping-cart mr-2" aria-hidden="true"></i>
            {{ aliasTranslations?.add_to_cart || $t("carts.addToCart") }}
          </el-button>
          <el-button v-else size="large" class="w-full large-button" disabled>
            {{ "已售完" }}
          </el-button>
        </div>
      </template>
      <el-card :body-style="{ padding: '1rem' }">
        <div class="flex" :class="isMobile ? ['gap-2'] : ['gap-4']">
          <div>
            <el-image class="assort-thumnail" :src="assortImgSrc" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
              :preview-src-list="assortImgSrcList" :initial-index="4" fit="cover" :style="{
                width: '100px',
                height: '100px',
              }" />
          </div>
          <div class="flex flex-column justify-content-center">
            <template v-if="selectedAssort.id">
              <span class="text-lg font-weight-bold">
                {{ dataTranslations(selectedAssort.name_translations) }}
              </span>
              <span v-if="!hiddenPrice" class="block">
                <div class="text-accent mr-2">
                  {{ currencySymbol }}
                  {{ $n(selectedAssort.sale_price || 0) }}
                </div>
                <div class="text-muted">
                  <s>
                    {{ aliasTranslations?.comm_price || $t("carts.commPrice") }}:
                    {{ currencySymbol }}
                    {{ $n(selectedAssort.comm_price || 0) }}
                  </s>
                </div>
              </span>
            </template>
            <template v-else>
              <span class="text-xl font-weight-bold text-accent">{{ "已售完" }}</span>
            </template>
          </div>
        </div>
        <el-card class="dim-selector">
          <template #header>
            <span>商品組合:</span>
          </template>
          
          <div v-for="assort in state.product.assorts" :key="assort.id">
            <el-radio-group v-model="state.selected_assort_id" size="large"
              class="d-flex flex-column align-items-start" @change="handleChooseAssortOnChange(assort)">
              <el-radio :label="assort.id"
                class="text-wrap" style="height: auto; min-height: 40px;" border>
                {{ dataTranslations(assort.name_translations) }}
              </el-radio>
            </el-radio-group>
          </div>
        </el-card>
      </el-card>
      <!-- <div style="min-height: calc(50vh);"></div> -->
    </el-dialog>

  </div>
</template>

<script setup>
import { reactive, computed, watch, toRaw } from "vue";
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n"
import { dataTranslations, breakpoint, notificationErrors, getAssorts, lookupAliasTranslations } from "../../utils";
import { _api_createCartGroup } from "../../api/index.js";
import { ElLoading } from 'element-plus'

const props = defineProps({
  promotion: Object,
  storeData: Object,
})
const { t, n, locale } = useI18n()
const store = useStore()
const storeData = computed(() => store.getters["lite/storeData"] || props.props);

const isMobile = computed(() => breakpoint.value.xs)
const hiddenPrice = computed(() => !!storeData.value?.settings?.hidden_price)
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart)
const hiddenContact = computed(() => !!storeData.value?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(storeData.value?.alias_translations, locale.value))

// const productFirstImage = computed(() => state.product?.image_url)
const productFirstImage = computed(() => state.product?.images?.filter((img) => img?.media?.type === 'image')?.[0]);

const assortFirstImage = computed(() => state.selected_assort?.image_url)
const assortImgSrc = computed(() => assortFirstImage.value || productFirstImage.value?.media?.url)
const assortImgSrcList = computed(() => [assortImgSrc.value])
const assortById = computed(() => state.product?.assorts.reduce(
  (prev, curr) => ({ ...prev, [curr.id]: { ...curr } }),
  {}
))
const selectedAssort = computed(() => state.selected_assort || {});
const currencySymbol = computed(() => state.selected_assort?.symbol || state.selected_assort?.currency);

const state = reactive({
  visible: false,
  product: {},
  selected_assort_id: null,
  selected_assort: {},
})

const handleClickClose = () => {
  store.commit('lite/resetProductChooseAssortDialog');
}

const chooseAssortSubmit = () => {
  if (!state.product.id || !selectedAssort.value.id) {
    swal.fire({
      text: '請先選擇【商品組合】',
      type: 'error',
    });
    return;
  }
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  const item = {
    store_product_id: state.product.id,
    store_assort_id: selectedAssort.value.id,
    quantity: 1,
    prod_name: dataTranslations(state.product.name_translations),
    prod_assort_name: dataTranslations(selectedAssort.value.name_translations),
    price: selectedAssort.value.sale_price,
  };
  const payload = {
    event_id: props.promotion.id,
    event_name: dataTranslations(props.promotion.title_translations),
    event_type: props.promotion.type,
    items: [item],
  };
  // console.log("handleQuickAddToCart", payload);

  _api_createCartGroup(payload)
    .then((res) => {
      localStorage.removeItem('ADD_TO_CART_GROUP')
      const eventID = res?.headers?.["x-request-id"] ? res?.headers?.["x-request-id"] : null
      aibTrackers.addToCart(payload, null, eventID)
      gtmTrackers.addToCart(payload, null, eventID)
      fbqTrackers.addToCart(payload, null, eventID)
      ttqTrackers.addToCart(payload, null, eventID)
      gtagTrackers.addToCart(payload, null, eventID)
      store.dispatch('lite/updateCart');
      handleClickClose();
      swal.fire({
        title: "已加到購物車",
        type: "success",
        showCancelButton: true,
        focusConfirm: true,
        reverseButtons: true,
        confirmButtonColor: "var(--primary_color)",
        confirmButtonText: aliasTranslations.value?.checkout ? aliasTranslations.value?.checkout : t("carts.checkout"),
        // cancelButtonColor: "var(--info)",
        cancelButtonText: "繼續逛逛",
      }).then((result) => {
        if (result.value) {
          const scrollToViewCarts = () => {
            // 檢查有沒有被 swal2 遮到，等 swal2 完全關閉再 scrollIntoView
            const swalContainer = document.getElementsByClassName('swal2-container')?.length;
            if (swalContainer) {
              setTimeout(scrollToViewCarts, 100);
              return;
            }
            const scrollElem = document.getElementById("block-carts");
            scrollElem &&
              scrollElem.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
          }
          scrollToViewCarts();
        }
      });
    })
    .catch((err) => {
      if (err?.errors) {
        const { type, msg } = err.errors[0]
        if (type == "RequireLoginError") {
          const temp = { "payload": payload, "redirect": redirect }
          localStorage.setItem('ADD_TO_CART_GROUP', JSON.stringify(temp))
        } else {
          localStorage.removeItem('ADD_TO_CART_GROUP')
        }
      }
      notificationErrors(err)
    })
    .finally(() => {
      window.ElFullPageLoading && window.ElFullPageLoading.close();
    })
}

const handleChooseAssortOnChange = (assort) => {
  // console.debug("handleChooseAssortOnChange", assort)
  state.selected_assort = assort
}
const initPromotionAssorts = () => {
  const ids = Object.keys(props.promotion?.discountable_store_product_assorts_map)
  const assorts = state.product.assorts.filter((el) => ids.includes(el.id.toString()))
  // console.debug("initPromotionAssorts", toRaw(assorts))
  state.product.assorts = toRaw(assorts)
  state.product.assorts = getAssorts(state.product, storeData.value?.currency)
  handleChooseAssortOnChange(toRaw(state.product?.assorts[0]))
  state.selected_assort_id = state.selected_assort.id
}

watch(
  () => store.getters['lite/productChooseAssortDialogDataUpdateAt'],
  () => {
    const { visible, data } = store.getters['lite/productChooseAssortDialog'];
    state.visible = visible;
    state.product = data;
    if (state.product?.assorts && !!state.product?.assorts.length) {
      initPromotionAssorts()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="">
  
</style>